import { svgIconClasses } from "@mui/material";
import IconButton$1 from "@mui/material/IconButton/index.js";
import { styled } from "@mui/material/styles";
const IconButton = styled(IconButton$1)(({ theme }) => ({
  color: theme.palette.grey[800],
  cursor: "pointer",
  [`.${svgIconClasses.root}`]: {
    width: "20px",
    height: "20px"
  }
}));
export {
  IconButton
};
